import React from 'react';
import ContactBanner from '../atoms/ContactBanner';

const Footer = () => (
  <>
    <footer style={{ backgroundColor: '#282a27' }}>
      <ContactBanner style={{ marginTop: '30px', height: '200px' }} />
      <div style={{ textAlign: 'center' }}>
        <div className="footer_info">
          <ul>
            <li>{process.env.REACT_APP_TITLE}</li>
            {' '}
            <li>
              대표자 :
              {process.env.REACT_APP_OWNER}
            </li>
            {' '}
            <li>
              주소 :
              {process.env.REACT_APP_ADDRESS}
            </li>
            <li>
              휴대폰 :
              {process.env.REACT_APP_HP}
            </li>
          </ul>
          <ul>
            <li>
              Copyright(c)
              {' '}
              {process.env.REACT_APP_TITLE}
              . All Rights Reserved.
              {' '}
            </li>
          </ul>
        </div>
      </div>
    </footer>
  </>
);

export default Footer;
